// extracted by mini-css-extract-plugin
module.exports = {"wrp":"About_wrp__3SUnR"};